import React from 'react'
import { Card, CardContent, CardHeader } from '@/shared/ui'
import { AlertTriangle } from 'lucide-react'
import { detectNearBreak } from '../utils/nearBreak'

// Pequeno helper local para exibir TF em texto curto
function tfLabel(tfRaw?: string | null): string | null {
  const t = String(tfRaw || '').toUpperCase()
  if (!t) return null
  if (t === '5') return '5min'
  if (t === '15') return '15min'
  if (t === '30') return '30min'
  if (t === '60') return '1h'
  if (t === '240') return '4h'
  if (t === '720') return '12h'
  if (t === 'D') return 'Diário'
  if (t === 'W') return 'Semanal'
  if (t === 'M') return 'Mensal'
  return t
}

// Pai imediato na hierarquia (M > W > D > 720 > 240 > 60 > 30 > 15 > 5)
function parentTf(tf?: string | null): string | null {
  const t = String(tf || '').toUpperCase()
  if (!t) return null
  if (t === '5') return '15'
  if (t === '15') return '30'
  if (t === '30') return '60'
  if (t === '60') return '240'
  if (t === '240') return '720'
  if (t === '720') return 'D'
  if (t === 'D') return 'W'
  if (t === 'W') return 'M'
  return null
}

export default function MandateWarningCard({ data }: { data: any }) {
  const cf = (data as any)?.confluence_factors || (data as any)?.confluence || {}
  const targetTf: string | null = (data as any)?.target_timeframe || cf.target_timeframe_raw || (data as any)?.maior_timeframe || null
  const parent = parentTf(targetTf)
  if (!parent) return null

  // Regras de proximidade: 1% a 0.06% (alerta âmbar);
  // <= 0.05% fica a cargo do NearBreakCard (vermelho)
  const trend = String((data as any)?.target_trend ?? '').toLowerCase()
  const nb = detectNearBreak(cf, trend)
  const thrAmberUpper = 1.0
  const thrAmberLower = 0.06
  const thrCritical = 0.05

  const parentPct = nb?.parentPct
  const critical = (nb?.targetPct != null && nb.targetPct <= thrCritical) || (parentPct != null && parentPct <= thrCritical)
  if (critical) return null

  const parentDirOk = (() => {
    if (!nb || !nb.parent) return false
    const bull = trend === 'bullish' || trend === 'alta'
    return bull ? nb.parent === 'down' : nb.parent === 'up'
  })()
  const showAmber = parentPct != null && parentDirOk && parentPct <= thrAmberUpper && parentPct >= thrAmberLower
  if (!showAmber) return null

  const candidateLabel = tfLabel(parent)
  const targetLabel = tfLabel(targetTf)

  return (
    <Card className="border-amber-500/30 bg-amber-500/5">
      <CardHeader className="flex items-center gap-2 text-amber-500">
        <AlertTriangle className="h-4 w-4" />
        <span className="text-sm font-semibold">{'Poss\u00EDvel troca de mandante'}</span>
      </CardHeader>
      <CardContent className="text-sm text-amber-500">
        <div>
          O timeframe superior {candidateLabel ? `(${candidateLabel})` : ''} pode assumir o mandante em breve.
          {targetLabel ? ` O alvo atual ${targetLabel} pode ser atualizado caso o superior confirme a correção.` : ''}
        </div>
      </CardContent>
    </Card>
  )
}
